// Pure helpers for tree-row multi-selection. No DOM — operates on path
// strings + immutable Set<string> snapshots that the React state can swap in.

export function singleSelect(path) {
  return new Set([path]);
}

export function clearSelection() {
  return new Set();
}

export function toggleSelection(set, path) {
  const next = new Set(set);
  if (next.has(path)) next.delete(path);
  else next.add(path);
  return next;
}

/**
 * Build a new selection by adding every row between anchorPath and targetPath
 * (inclusive, in either direction) to existingSet.
 *
 * Returns existingSet unchanged when either endpoint is missing (e.g. a row
 * scrolled out of the virtual tree). This preserves the prior selection rather
 * than silently wiping it.
 */
export function selectRange(rows, anchorPath, targetPath, existingSet) {
  const a = rows.findIndex((r) => r.path === anchorPath);
  const b = rows.findIndex((r) => r.path === targetPath);
  if (a < 0 || b < 0) return existingSet;
  const [lo, hi] = a <= b ? [a, b] : [b, a];
  const next = new Set(existingSet);
  for (let i = lo; i <= hi; i++) next.add(rows[i].path);
  return next;
}
